module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-03.53272a57.jpg";